import { FastField, FieldProps } from 'formik';
import { memo } from 'react';

import { FormControlTextInput, IconCheck, tokens } from '@fhs/ui';
import { useOrderContext } from '@fhs-legacy/frontend/src/state/order';
import { CHECKOUT_DELIVERY_UNIT_NUMBER_INPUT } from '@fhs-legacy/frontend/src/utils/test-ids';

function UnitNumberField() {
  const { setDeliveryAddress } = useOrderContext();

  return (
    <FastField name="unitNumber">
      {({ field, meta }: FieldProps) => {
        const handleBlur = (e: any) => {
          field.onBlur('unitNumber')(e);
          setDeliveryAddress(prev => ({
            ...prev,
            addressLine2: field.value?.trim() ?? '',
          }));
        };

        return (
          <FormControlTextInput
            testID={CHECKOUT_DELIVERY_UNIT_NUMBER_INPUT}
            label="Unit Number (Optional)"
            placeholder="Enter unit number"
            value={field.value}
            onChangeText={field.onChange('unitNumber')}
            onBlur={handleBlur}
            error={meta.touched && meta.error ? meta.error : undefined}
            rightIcon={
              !meta.error && field.value ? (
                <IconCheck size={20} color={tokens.colors.$success} />
              ) : undefined
            }
          />
        );
      }}
    </FastField>
  );
}

export default memo(UnitNumberField);
